import app from '../firebase';
import {
    getFirestore,
    collection,
    getDocs,
} from 'firebase/firestore';
import { useState, useEffect } from 'react';

import cafemoto from '../media/cafemoto.png';
import _1 from '../media/1.png';
import _2 from '../media/2.png';
import _3 from '../media/3.png';

export default function Foods() {

    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'PHP' });

    const [foods, setFoods] = useState([]);

    const getFoods = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'products'))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        setFoods(x);
    }

    useEffect(() => {
        getFoods();
    }, []);

    return(
        <>
            <img src={cafemoto} className="img-fluid w-100" alt="" />

            <div className="container-fluid min-vh-100 bg-light p-4">
                
                <h2>Food</h2>

                <br />

                <div className="row g-2">
                        <a href="/" className="col-6 col-md-4">
                            <div className="h-100 rounded-3">
                                <img src={_1} className="img-fluid mb-2" alt="" />
                                <small className="d-block text-center">Food 1</small>
                                <small className="d-block text-center text-da fw-bold">PHP 120.00</small>
                            </div>
                        </a>

                        <a href="/" className="col-6 col-md-4">
                            <div className="h-100 rounded-3">
                                <img src={_2} className="img-fluid mb-2" alt="" />
                                <small className="d-block text-center">Food 1</small>
                                <small className="d-block text-center text-da fw-bold">PHP 120.00</small>
                            </div>
                        </a>

                        <a href="/" className="col-6 col-md-4">
                            <div className="h-100 rounded-3">
                                <img src={_3} className="img-fluid mb-2" alt="" />
                                <small className="d-block text-center">Food 1</small>
                                <small className="d-block text-center text-da fw-bold">PHP 120.00</small>
                            </div>
                        </a>
                </div>
            </div>
        </>
    )
}